<template>
  <nav :class="navbarClasses">
    <slot />
  </nav>
</template>
<script>
export default {
  name: "BNavbar",
  props: {
    tag: {
      type: String,
      default: "nav",
    },
    type: {
      type: String,
      default: "dark",
    },
    variant: {
      type: String,
      default: "white",
    },
    expand: {
      type: String,
      default: "md",
    },
    fixed: {
      type: String,
      default: null,
    },
    print: {
      type: Boolean,
      default: false,
    },
    sticky: {
      type: Boolean,
      default: false,
    },
    toggleable: {
      type: [Boolean, String],
      default: false,
    },
  },
  computed: {
    navbarClasses() {
      return {
        navbar: true,
        [`navbar-${this.type}`]: true,
        [`bg-${this.variant}`]: true,
        [`navbar-expand-${this.expand}`]: true,
        [`fixed-${this.fixed}`]: this.fixed,
        "d-print": this.print,
        "sticky-top": this.sticky,
        "navbar-toggleable": this.toggleable === true,
        [`navbar-toggleable-${this.toggleable}`]: typeof this.toggleable === "string",
      };
    },
  },
};
</script>
